<template>
  <CheckboxGroup
    v-model="checkValue"
    @change="handleChange"
    style="width: 100%"
    :disabled="disabled"
  >
    <div class="check-item" v-for="(item, index) in data.optionsList" :key="index">
      <Checkbox checked-color="rgb(215, 0, 15)" :name="item.id ? item.id : item.optionContent">
        {{ item.optionContent }}
      </Checkbox>
      <Field
        class="other-class"
        v-if="item.othersFlag === '1'"
        v-model="otherValue"
        show-word-limit
        :maxlength="500"
        :placeholder="data.remind"
        @blur="handleChange"
      />
    </div>
  </CheckboxGroup>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Field, CheckboxGroup, Checkbox } from 'vant'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: Array,
    default: []
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'change'])
const checkValue = ref(props.value)

const otherValue = ref('')

// 暂定入参
const handleChange = () => {
  let arr = props.data.optionsList
    .filter(item => checkValue.value.includes(item.id ? item.id : item.optionContent))
    .map(item => ({
      optionId: item.id || item.optionContent,
      otherContent: item.othersFlag === '1' ? otherValue.value : '',
      othersFlag: item.othersFlag === '1' ? '1' : undefined
    }))
  emit('change', arr)
}
onMounted(async () => {
  if (props.data.fieldValue) {
    checkValue.value = props.data.fieldValue.map(item => item.optionId)
    otherValue.value =
      props.data.fieldValue.find(item => item.otherContent)?.otherContent || undefined
  }
})
</script>

<style lang="less" scoped>
.check-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
  :deep(.van-checkbox) {
    min-height: 40px;
    .van-checkbox__label {
      color: rgba(0, 0, 0, 0.7);
    }
  }
}
.other-class {
  padding: 2px 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.04);
  margin-top: 8px;
  border-bottom: none !important;
  padding-bottom: 0 !important;
}
:deep(.van-field__word-limit) {
  border-bottom: none !important;
  padding-bottom: 0 !important;
}
</style>
